import { setUnsavedTyping } from './appVersionStore';

const FORM_FIELD_SELECTOR =
    'input, textarea, select, [contenteditable=""], [contenteditable="true"]';
/** 頂欄與側邊欄的控制項（語言、主題）不是表單內容，不算「尚未儲存的輸入」 */
const APP_CHROME_SELECTOR = 'header, nav';
const TYPING_EVENTS = ['input', 'change'] as const;

function isFormContentEvent(event: Event): boolean {
    const target = event.target;
    return (
        target instanceof Element &&
        target.matches(FORM_FIELD_SELECTOR) &&
        target.closest(APP_CHROME_SELECTOR) === null
    );
}

/**
 * 粗略判斷使用者有沒有在欄位裡打字。無法得知表單何時送出，所以只在換頁時由呼叫端歸零；
 * 寧可多提醒一次（瀏覽器的離開確認），也不要讓櫃台人員重打整張表單。
 */
export function trackUnsavedTyping(doc: Document = document): () => void {
    const markTyping = (event: Event) => {
        if (isFormContentEvent(event)) setUnsavedTyping(true);
    };
    TYPING_EVENTS.forEach((type) => doc.addEventListener(type, markTyping, true));
    return () => TYPING_EVENTS.forEach((type) => doc.removeEventListener(type, markTyping, true));
}
